let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("hPzOn"), load("eNmuD"), load("h2MrD"), load("bYT2S"), load("cM9em"), load("fr9NE"), load("36IoX")]).then(() => parcelRequire('3AQ56'));